import md5 from "js-md5";

export let sign = (data)=>{
  let key = "bluecat2021"; //签名Key
  let keys = [];
  console.log(data)
  for (let k in data){
      if (k == 'sign' || k == 'undefined' || k == '0' || k == 0 || k == 'null' || k ==null){
          continue;
      }
      keys.push(k);
  }
  //排序
  keys.sort();
  console.log(keys)
  let kv = [];
  for (let k of keys){
    let m = data[k];
    // 过滤空值：空字符串、null、undefined、false、0、'0'、'undefined'、'null'、'false'、空数组、空对象
    if (m === null || m === undefined || m === '' || m === 0 || m === '0') continue;
    if (m === 'undefined' || m === 'null' || m === 'false') continue;
    if (Array.isArray(m) && m.length === 0) continue;
    if (typeof m === 'object' && !Array.isArray(m) && Object.keys(m).length === 0) continue;
    kv.push(k + '=' + m);
  }
  //

  let signStr = kv.join('&');
  console.log(signStr)
  console.log(99)
  signStr = signStr + "&key="+key;
  signStr = md5(signStr)
  return signStr;
}